import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetWikiPageContentArgs, WikiPageState } from "../Model";
import { RootState } from "..";
import { getWikiPageContent as getWikiPageContentApi } from "../../Api";

const initialState: WikiPageState = {
  pageUrl: null,
  isLoaded: false,
  pageContent: ''
}

export const WikiPageSlice = createSlice({
  name: 'wikiPage',
  initialState: initialState,
  reducers: {
    setPageUrl: (state, action) => {
      if (state.pageUrl !== action.payload) {
        state.pageUrl = action.payload;
        state.isLoaded = false;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getWikiPageContent.fulfilled, (state, action: PayloadAction<string | null>) => {      
      state.isLoaded = true;
      if (action.payload !== null) {
        state.pageContent = action.payload;
        const location = state.pageUrl !== null ? extractLocation(state.pageUrl) : '';
        state.pageContent = replaceURLs(state.pageContent, location);
        
      } else if (state.pageUrl !== null) {
        let decodedUrl = decodeURIComponent(state.pageUrl);

        decodedUrl = decodedUrl.replaceAll('%2d', '-');
        decodedUrl = decodedUrl.replaceAll('-', ' ');

        let matches = decodedUrl.match('((?:.(?!/))+$)');

        if (matches) {
          let title = matches[0];

          title = title.replaceAll('/', '');
          title = title.replaceAll('.md', '');
          state.pageContent = `# ${title}`;
        } else {
          state.pageContent = `# ${decodedUrl}`;
        }
      } else {
        state.pageContent = '# Brak treści';
      }
    });
  }
});

export const getWikiPageContent = createAsyncThunk(
  'wikiPage/getWikiPageContent',
  async (args: GetWikiPageContentArgs): Promise<string | null> => {
    if (args.wikiPage === null) return null;
    
    return await getWikiPageContentApi(args.context, args.repository, args.wikiPage);
  }
);

function extractLocation(input: string): string {
  const index = input.indexOf('%2');
  if (index !== -1) {
    return input.substring(0, index);
  }
  return input;
}

function replaceURLs(mdContent: string, location: string): string {
  const regex = /\[(.*?)\]\((\/[^)]+)\)/g;
  const replacedContent = mdContent.replace(regex, (match, text, url) => {
    const origin = window.location.origin;
    const newURL = `${origin}/#/${location}${encodeURIComponent(url).replace(/%2F/g, '%2f')}.md`;
    return `[${text}](${newURL})`;
  });
  return replacedContent;
}

export const selectPageUrl = (state: RootState) => state.wikiPage.pageUrl;
export const selectIsLoaded = (state: RootState) => state.wikiPage.isLoaded;
export const selectPageContent = (state: RootState) => state.wikiPage.pageContent;
export const { setPageUrl } = WikiPageSlice.actions;
export default WikiPageSlice.reducer;